import { getBackupEnterprise } from "../../../../../api/backup/backup";

export const ReadBackupEnterprise = async (page = 1) => {
  try {
    const response = await getBackupEnterprise(page);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
